import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Input, useMenuStateContext } from '@maui/elements'

import { defaultOptions } from './options'
import { RangeMenu } from './RangeMenu'

export const RangeSelect = ({
  value: propsValue,
  range: propsRange,
  onCommit,
  min,
  ranges,
}) => {
  const { hide } = useMenuStateContext()
  const [value, setValue] = useState(propsValue)
  const [range, setRange] = useState(propsRange)

  useEffect(() => {
    setValue(propsValue)
  }, [propsValue, setValue])

  useEffect(() => {
    setRange(propsRange)
  }, [propsRange, setRange])

  const onClickCommit = useCallback(() => {
    onCommit({
      value: value === '' ? propsValue : value,
      range,
    })
    hide()
  }, [hide, onCommit, range, propsValue, value])

  const onValueChange = useCallback(e => {
    const value = Number(e.target.value)
    setValue(isNaN(value) || value < 1 ? '' : value.toString())
  }, [setValue])

  const onValueBlur = useCallback(e => {
    const value = Number(e.target.value)

    if (isNaN(value) || value < 1) {
      setValue(propsValue)
    } else if (value.toString() !== e.target.value) {
      setValue(value.toString())
    }
  }, [setValue, propsValue])

  const onValueFocus = useCallback(e => {
    e.target.select()
  }, [])

  return (
    <Box borderRadius="4px">
      <Box
        padding="16px"
        display="flex"
        alignItems="center"
        gap="8px"
      >
        <Input
          type="number"
          width="60px"
          value={value}
          onBlur={onValueBlur}
          onChange={onValueChange}
          onFocus={onValueFocus}
          min={min}
          height="34px"
        />
        <RangeMenu
          onChange={setRange}
          range={range}
          value={value}
          ranges={ranges}
        />
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        padding="16px"
        borderTopColor="colorBorderMain"
        borderTopWidth="1px"
        borderTopStyle="solid"
        gap="8px"
      >
        <Button onClick={hide} variant="secondary">
          Cancel
        </Button>
        <Button onClick={onClickCommit}>
          Apply
        </Button>
      </Box>
    </Box>
  )
}

RangeSelect.defaultProps = {
  min: 1,
  ranges: defaultOptions.ranges,
}

RangeSelect.propTypes = {
  value: PropTypes.number,
  range: PropTypes.string,
  onCommit: PropTypes.func.isRequired,
  min: PropTypes.number,
  ranges: PropTypes.arrayOf(PropTypes.string),
}
